import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tabs', 'selectTab', 'Select tab');
Labels.set('ui-tabs', 'left', 'Scroll to the left');
Labels.set('ui-tabs', 'right', 'Scroll to the right');
